module.exports = __webpack_public_path__ + "static/img/vip_h@2x.aa65d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/vip_h@2x.png
// module id = 6BrM
// module chunks = 96